import * as React from "react";
import { Row, Col, Input } from "antd";
import signature from "../../assets/images/signature.png";
import { TPaymentConfirmationPresentationModel } from "../../../presenter/payment/model/PaymentConfirmationPresentationModel";
import Text from "antd/lib/typography/Text";
import TextArea from "antd/lib/input/TextArea";

const AbroadPaymentForm = ({
  paymentConfirmationData,
  translate
}: {
  paymentConfirmationData: TPaymentConfirmationPresentationModel;
  translate: any;
}) => {
  return (
    <React.Fragment>
      <div className="content-container">
        <div className="content-section">
          <div className="content-section-border">
            <Row>
              <Text className={"content-section-title"}>
                {translate("payment_confirmation_page.sender_title")}
              </Text>
            </Row>
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.sender_name")}
              </Text>
              <TextArea
                rows={3}
                readOnly
                className={"input"}
                value={paymentConfirmationData.senderName}
              />
            </Row>
            <Row className={"group-items"}>
              <Text className={"label"}>
                {translate("payment_confirmation_page.sender_account")}
              </Text>
              <Input
                readOnly
                className={"input"}
                value={paymentConfirmationData.senderAccount}
              />
            </Row>
          </div>
          <div className="content-section-border">
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col
                className={"label-container"}
                style={{ marginBottom: "-0.15em" }}
              >
                <Text className={"label"}>
                  {translate(
                    "payment_confirmation_page.ino_amount_and_currency"
                  )}
                </Text>
              </Col>
              <Col lg={20} sm={19} xs={16}>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.amount}
                />
              </Col>
              <Col lg={4} sm={5} xs={8}>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.destinationCurrency}
                />
              </Col>
            </Row>
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col
                className={"label-container"}
                style={{ marginBottom: "-0.15em" }}
              >
                <Text className={"label"}>
                  {translate(
                    "payment_confirmation_page.coverage_amount_and_currency"
                  )}
                </Text>
              </Col>
              <Col lg={20} sm={19} xs={16}>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.coverageAmount}
                />
              </Col>
              <Col lg={4} sm={5} xs={8}>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.coverageCurrency}
                />
              </Col>
            </Row>
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.payment_description")}
                </Text>
                <TextArea
                  readOnly
                  rows={3}
                  className={"input"}
                  value={paymentConfirmationData.description}
                />
              </Col>
            </Row>

            <Row className={"group-items"} gutter={[8, 8]}>
              <Col lg={12} sm={12} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.processing_date")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.processingDate}
                />
              </Col>

              <Col lg={12} sm={12} xs={24} className={"signature-wrapper"}>
                <img src={signature} alt="Bank stamp" />
              </Col>
            </Row>
          </div>
        </div>
        <div className="content-section">
          <div className="content-section-emphasize">
            <Row>
              <Text className={"content-section-title"}>
                {translate("payment_confirmation_page.receiver_ino")}
              </Text>
            </Row>
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col xl={24} sm={24} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.iban_receiver_account")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.receiverAccount}
                />
              </Col>
              <Col xl={24} sm={24} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.receiver_name")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.receiverName}
                />
              </Col>
            </Row>
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col xl={24} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.receiver_address")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.address}
                />
              </Col>
              <Col xl={24} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.postal_code")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.address2}
                />
              </Col>
            </Row>
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col xl={8} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.bic_code")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.bicCode}
                />
              </Col>
              <Col xl={16} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.bank_name")}
                </Text>
                <TextArea
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.bankName}
                />
              </Col>
            </Row>
          </div>
          <div className="content-section-emphasize">
            {paymentConfirmationData.paymentPurposeVisible ? (
              <Row className={"group-items"} gutter={[8, 8]}>
                <Col>
                  <Text className={"label"}>
                    {translate("payment_confirmation_page.payment_purpose")}
                  </Text>
                  <Input
                    readOnly
                    className={"input"}
                    value={paymentConfirmationData.paymentPurpose}
                  />
                </Col>
              </Row>
            ) : (
              <div />
            )}
            <Row className={"group-items"} gutter={[8, 8]}>
              <Col lg={12} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.expenses_beared_by")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.expensesBaredBy}
                />
              </Col>
              <Col lg={12} xs={24}>
                <Text className={"label"}>
                  {translate("payment_confirmation_page.abroad_execution_time")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentConfirmationData.abroadExecutionTime}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AbroadPaymentForm;
